const TZ = "Australia/Brisbane";

export function money(cents: number | null | undefined, opts: { short?: boolean } = {}) {
  if (cents == null) return "";
  const d = cents / 100;
  if (opts.short) {
    if (d >= 1_000_000) return `$${(d / 1_000_000).toFixed(d >= 10_000_000 ? 0 : 2).replace(/\.?0+$/, "")}m`;
    if (d >= 1000) return `$${Math.round(d / 1000)}k`;
  }
  return d.toLocaleString("en-AU", { style: "currency", currency: "AUD", maximumFractionDigits: 0 });
}

export function phone(e164: string | null | undefined) {
  if (!e164) return "";
  const m = e164.match(/^\+61(4\d{2})(\d{3})(\d{3})$/);
  if (m) return `0${m[1]} ${m[2]} ${m[3]}`;
  const l = e164.match(/^\+61([2378])(\d{4})(\d{4})$/);
  if (l) return `(0${l[1]}) ${l[2]} ${l[3]}`;
  return e164;
}

const dayKey = (d: Date) => d.toLocaleDateString("en-CA", { timeZone: TZ });
export const todayKey = () => dayKey(new Date());

/** "9:42am", "Yesterday", "Mon", "14 Oct" — short, for lists. */
export function when(iso: string | null | undefined) {
  if (!iso) return "";
  const d = new Date(iso);
  const days = Math.round((new Date(todayKey()).getTime() - new Date(dayKey(d)).getTime()) / 86400000);
  if (days === 0) return time(iso);
  if (days === 1) return "Yesterday";
  if (days > 1 && days < 7) return d.toLocaleDateString("en-AU", { weekday: "short", timeZone: TZ });
  return d.toLocaleDateString("en-AU", { day: "numeric", month: "short", timeZone: TZ, ...(days > 300 ? { year: "numeric" } : {}) });
}

export const time = (iso: string) => new Date(iso).toLocaleTimeString("en-AU", { hour: "numeric", minute: "2-digit", timeZone: TZ }).replace(" ", "").toLowerCase();

export function dateLong(isoDate: string) {
  return new Date(isoDate + (isoDate.length === 10 ? "T12:00:00" : "")).toLocaleDateString("en-AU", { weekday: "long", day: "numeric", month: "long", timeZone: TZ });
}
export function dateShort(isoDate: string | null | undefined) {
  if (!isoDate) return "";
  return new Date(isoDate + (isoDate.length === 10 ? "T12:00:00" : "")).toLocaleDateString("en-AU", { day: "numeric", month: "short", timeZone: TZ });
}
export function dayLabel(iso: string) {
  const days = Math.round((new Date(todayKey()).getTime() - new Date(dayKey(new Date(iso))).getTime()) / 86400000);
  if (days === 0) return "Today";
  if (days === 1) return "Yesterday";
  return new Date(iso).toLocaleDateString("en-AU", { weekday: "long", day: "numeric", month: "short", timeZone: TZ });
}
/** Days from today to a YYYY-MM-DD date (negative = past). */
export const daysUntil = (isoDate: string) => Math.round((new Date(isoDate + "T00:00:00Z").getTime() - new Date(todayKey() + "T00:00:00Z").getTime()) / 86400000);

export const initials = (name: string) => name.replace(/\(.*?\)/g, "").split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";

export const LABEL: Record<string, string> = {
  buyer: "Buyer", seller_prospect: "Seller lead", vendor: "Vendor", past_client: "Past client", investor: "Investor", landlord: "Landlord",
  tenant: "Tenant", solicitor: "Solicitor", conveyancer: "Conveyancer", broker: "Broker", referrer: "Referrer", tradie: "Tradie", agent: "Agent", other: "Other",
  sms: "Text", call: "Call", voicemail: "Voicemail", email: "Email", facebook: "Facebook", instagram: "Instagram", webchat: "Website chat",
  form: "Website form", portal_enquiry: "Portal enquiry", internal: "Note",
  enquired: "Enquired", inspected: "Inspected", offered: "Offered", under_contract: "Under contract", purchased: "Purchased", not_interested: "Not interested",
  birthday: "Birthday", purchase_anniversary: "Purchase anniversary", authority_expiry: "Form 6 expires", finance_due: "Finance due",
  building_pest_due: "Building & pest due", settlement_due: "Settlement", deposit_due: "Deposit due", contract_date: "Contract",
  unconditional: "Unconditional", appraisal: "Appraisal", open_home: "Open home", inspection: "Inspection", custom: "Date", due_diligence_due: "Due diligence",
  owner: "Owner", admin: "Admin", system: "System",
  note: "Note", call_log: "Call log", feedback: "Inspection feedback", price_feedback: "Price feedback", vendor_update: "Vendor update",
  low: "Low", medium: "Medium", high: "High", very_high: "Very high",
};
export const label = (k: string | null | undefined) => (k ? LABEL[k] ?? k.replace(/_/g, " ") : "");
